import React from "react";
import {
  Grid,
  Typography,
  Container,
  Icon,
  Card,
  CardActionArea,
  CardMedia,
  CardContent,
  CardActions,
  Button,
  ClickAwayListener,
  MenuList,
  MenuItem,
  IconButton,
  CardHeader,
  Hidden,
  TextField,
  InputAdornment,
  Divider,
  LinearProgress,
  Backdrop,
  CircularProgress,
  Grow,
  FormControl,
  FormHelperText,
} from "@material-ui/core";
import MagicHover from "magic-hover";
import bgImg from "../../assets/img/productCurvyLines.png";
import { Redirect, useParams } from "react-router-dom";
import { LOCALE, changeLanguage } from "../../properties/Locale";
import { makeStyles } from "@material-ui/core/styles";
import styles from "../../assets/jss/components/headerLinkStyle";
import { Alert, AlertTitle } from "@material-ui/lab";
import {
  LoginFormValidator,
  RegisterTokenFormValidator,
} from "./LoginFormValidator";
import { PropagateLoader } from "react-spinners";
import { AuthService } from "./AuthService";
import { ErrorMessageResolver } from "../../common/helpers/ErrorMessageResolver";
import { ChangeCertificateRepository } from "../../repositories/ChangeCertificateRepository";

const useStyles = makeStyles(styles);

export default function ResetCertificateComponent() {
  const [redirectTo, setRedirectTo] = React.useState();

  const [loading, setLoading] = React.useState(false);
  const [globalFormError, setGlobalFormError] = React.useState();
  const [tokenSuccess, setTokenSuccess] = React.useState(false);
  const [credentialsDataErrors, setCredentialsDataErrors] = React.useState({});
  const [responseMessage, setResponseMessage] = React.useState();
  const [changedPasswordSuccess, setChangedPasswordSuccess] =
    React.useState(false);
  const { id } = useParams();
  const [credentialsData, setCredentialsData] = React.useState({
    signedXml: "",
  });
  const useStyles = makeStyles((theme) => ({
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: "#fff",
    },
  }));
  const classes = useStyles();

  const signDocument = () => {
    if (typeof AuctaSignerApp === "function") {
      var xml = "<root>UVMK</root>";
      window.ext.signAndCertXML(xml, (status, message) => {
        signAndCertCallback(status, message);
      });
    } else {
      setGlobalFormError(
        "Ве молиме инсталирајте ги потребните алатки за дигитално потпишување"
      );
    }
  };

  function signAndCertCallback(status, message) {
    if (status === false && message.status === "Error") {
      if (message.error === "No valid certificates.") {
        setGlobalFormError(
          "Не е избран валиден сертификат за дигитално потпишување"
        );
      } else if (
        message.error.includes("The action was cancelled by the user.")
      ) {
        setGlobalFormError("Потпишувањето беше откажано на ваше барање");
      } else {
        setGlobalFormError(
          "Грешка при потпишување на електронскиот документ. Ве молиме пријавете го овој проблем кај администраторот."
        );
      }
    } else if (status === true) {
      // console.log(status);
      // console.log(message);
      let data = { ...credentialsData };
      data["signedXml"] = message.signedContent;
      setTokenSuccess(status);
      setCredentialsData(data);
      setCredentialsDataErrors({});
      setGlobalFormError();
    }
  }

  const loginSubmitHandler = () => {
    setGlobalFormError();
    setCredentialsDataErrors({});
    setLoading(true);
    if (!RegisterTokenFormValidator.isValidSync(credentialsData)) {
      var validationErrors = {};
      (async () => {
        await RegisterTokenFormValidator.validate(credentialsData, {
          abortEarly: false,
        }).catch((err) => {
          err.inner.forEach((validationError) => {
            validationErrors[validationError.path] = {};
            validationErrors[validationError.path] = validationError.message;
          });
          setCredentialsDataErrors(validationErrors);
          setLoading(false);
          return;
        });
      })();
    } else {
      changeToken();
    }
  };

  const changeToken = () => {
    ChangeCertificateRepository.changeCertificate(
      id,
      credentialsData?.signedXml
    )
      .then((res) => {
        setGlobalFormError();
        setResponseMessage(res.data);
        setLoading(false);
        setChangedPasswordSuccess(true);
      })
      .catch((err) => {
        setGlobalFormError(ErrorMessageResolver.resolve(err));
        setLoading(false);
      });
  };

  React.useEffect(() => {
    if (changedPasswordSuccess === true) {
      setTimeout(() => {
        setRedirectTo("/login");
      }, 3000);
    }
  }, [changedPasswordSuccess]);

  return (
    <React.Fragment>
      {AuthService.getCurrentUser() !== null && <Redirect to={"/"} push />}
      {redirectTo && <Redirect to={redirectTo} push />}
      <Backdrop className={classes.backdrop} open={loading}>
        <PropagateLoader size={15} color={"#fff"} loading={loading} />
      </Backdrop>
      <div
        style={{
          backgroundImage: "url(" + bgImg + ")",
          backgroundSize: "100% 100%",
          minHeight: "100vh",
          backgroundAttachment: "fixed",
        }}
      >
        <Container>
          <Grid container>
            <Grid item sm={12} xs={12}>
              <Hidden smDown>
                <IconButton
                  onClick={() => setRedirectTo("/")}
                  style={{
                    color: "black",
                    position: "absolute",
                    left: "5%",
                    top: "45%",
                  }}
                >
                  <Icon>arrow_back_ios</Icon>
                </IconButton>
              </Hidden>
              <Hidden smUp>
                <IconButton
                  onClick={() => setRedirectTo("/")}
                  style={{
                    color: "black",
                    position: "absolute",
                    left: "5%",
                    top: "5%",
                  }}
                >
                  <Icon>arrow_back_ios</Icon>
                </IconButton>
              </Hidden>
            </Grid>
            <Grid item xs={12}>
              <Hidden smDown>
                <div style={{ marginTop: "10vh" }}></div>
              </Hidden>
            </Grid>
            <Grid item md={3} lg={3} sm={3} xs={false}></Grid>
            <Grid item md={6} lg={6} sm={6} xs={12} style={{ padding: "15px" }}>
              <Grid
                item
                xs={12}
                md={12}
                style={{ textAlign: "center", marginBottom: "20px" }}
              >
                <Hidden smDown>
                  <img
                    alt=""
                    src={require("../../assets/img/logo-uvmk.png")}
                    width="60px"
                    style={{
                      borderRight: "1px solid black",
                      paddingRight: "15px",
                      paddingTop: "5px",
                    }}
                  ></img>
                  <Typography
                    gutterBottom
                    style={{
                      textAlign: "left",
                      paddingTop: "5px",
                      marginLeft: "15px",
                      marginTop: "6px",
                      display: "inline-block",
                      verticalAlign: "top",
                    }}
                  >
                    {LOCALE.ministry_of_justice}
                    <br />
                    <strong>{LOCALE.uvmk}</strong>
                  </Typography>
                </Hidden>
                <Hidden mdUp>
                  <img
                    alt=""
                    src={require("../../assets/img/logo-uvmk.png")}
                    width="30px"
                    style={{ paddingRight: "5px", marginTop: "5px" }}
                  ></img>
                  <Typography
                    gutterBottom
                    style={{
                      paddingTop: "0px",
                      marginLeft: "5px",
                      marginTop: "6px",
                      display: "inline-block",
                      verticalAlign: "top",
                      fontSize: "11px",
                    }}
                  >
                    {LOCALE.ministry_of_justice}
                    <br />
                    <strong>{LOCALE.uvmk}</strong>
                  </Typography>
                </Hidden>
              </Grid>

              <Card>
                <div
                  style={{
                    textAlign: "center",
                    padding: "0px",
                    margin: "0px",
                    color: "white",
                    backgroundColor: "#70c1c2",
                  }}
                >
                  <Typography
                    gutterBottom
                    variant="h6"
                    component="h2"
                    style={{
                      textAlign: "center",
                      marginBottom: "0px",
                      padding: "10px",
                    }}
                  >
                    <Icon>lock_open</Icon>
                    <span style={{ verticalAlign: "top", lineHeight: "1.4" }}>
                      {LOCALE.certificateChange}
                    </span>
                  </Typography>
                </div>
                <CardContent>
                  <Grid container spacing={3}>
                    <Grid item xs={false} sm={false} md={1}></Grid>
                    <Grid item xs={12} sm={12} md={10}>
                      <Hidden smDown>
                        <br />
                      </Hidden>
                      <Grid container spacing={2}>
                        {responseMessage && (
                          <Grid item xs={12}>
                            <Alert severity={"success"}>
                              {LOCALE.getString(responseMessage)}
                            </Alert>
                          </Grid>
                        )}

                        {globalFormError && (
                          <Grid item xs={12}>
                            <Alert severity={"error"}>{globalFormError}</Alert>
                          </Grid>
                        )}
                        {!changedPasswordSuccess && (
                          <React.Fragment>
                            <Grow in={true} timeout={700}>
                              <Grid item xs={12}>
                                <FormControl
                                  variant="outlined"
                                  fullWidth
                                  size="small"
                                  error={credentialsDataErrors?.signedXml}
                                >
                                  <Button
                                    disabled={loading || tokenSuccess}
                                    size="medium"
                                    variant="contained"
                                    color="primary"
                                    style={{ color: "white" }}
                                    fullWidth={true}
                                    startIcon={
                                      tokenSuccess ? (
                                        <Icon>done</Icon>
                                      ) : (
                                        <Icon>usb</Icon>
                                      )
                                    }
                                    onClick={() => signDocument()}
                                    error={
                                      credentialsDataErrors.signedXml !=
                                      undefined
                                    }
                                    helperText={credentialsDataErrors.signedXml}
                                  >
                                    {tokenSuccess
                                      ? LOCALE.load_certificate_success
                                      : LOCALE.load_new_certificate}
                                  </Button>
                                  {credentialsDataErrors?.signedXml && (
                                    <FormHelperText error={true}>
                                      {credentialsDataErrors.signedXml}
                                    </FormHelperText>
                                  )}
                                </FormControl>
                              </Grid>
                            </Grow>
                            <Grow in={true} timeout={800}>
                              <Grid item xs={12}>
                                <Button
                                  disabled={
                                    loading || !credentialsData?.signedXml
                                  }
                                  size="medium"
                                  variant="contained"
                                  color="secondary"
                                  fullWidth={true}
                                  onClick={() => loginSubmitHandler()}
                                >
                                  {LOCALE.certificate_change}
                                </Button>
                              </Grid>
                            </Grow>
                          </React.Fragment>
                        )}

                        <Grow in={true} timeout={1200}>
                          <Grid item xs={6}>
                            <Button
                              size="small"
                              style={{
                                textDecoration: "none",
                                color: "black",
                              }}
                              onClick={() => setRedirectTo("/login")}
                            >
                              {LOCALE.login}
                            </Button>
                          </Grid>
                        </Grow>

                        <Grow in={true} timeout={1200}>
                          <Grid item xs={6} style={{ textAlign: "right" }}>
                            <Button
                              size="small"
                              style={{
                                textDecoration: "none",
                                color: "black",
                              }}
                              onClick={() => setRedirectTo("/signup")}
                            >
                              {LOCALE.registration}
                            </Button>
                          </Grid>
                        </Grow>
                      </Grid>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
          <Grid item md={3} lg={3} sm={3} xs={false}></Grid>
        </Container>
      </div>
    </React.Fragment>
  );
}
